<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'stock-confirm' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('writeOff.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('writeOff.pageTitle'),
            href: '/stock-confirm'
          },
          {
            text: $t('writeOff.showDetail'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('writeOff.writeOffInfo') }}
                    </legend>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.writeOffNumber') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{ edit_data.write_off_number }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.date') }}
                        :
                      </div>
                      <div class="col-md-3">{{ edit_data.write_off_date }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.confirmedBy') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{
                          edit_data.confirmed_by
                            ? edit_data.confirmed_by.employee
                              ? edit_data.confirmed_by.employee.employee_name_en
                              : ''
                            : ''
                        }}
                      </div>
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.confirmedDate') }}
                        :
                      </div>
                      <div class="col-md-3">
                        {{ edit_data.confirmed_date }}
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 text-right">
                        {{ $t('writeOff.isConfirm') }} :
                      </div>
                      <div class="col-md-3">
                        <span
                          class="badge badge-success"
                          v-if="edit_data.is_confirm"
                          >Yes</span
                        >
                        <span class="badge badge-danger" v-else>No</span>
                      </div>
                      <div class="col-md-3 text-right"></div>
                      <div class="col-md-3"></div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <form>
                  <fieldset>
                    <legend>
                      {{ $t('writeOff.writeOffDetail') }}
                    </legend>
                    <div class="overflow-auto max-h">
                      <ts-table :columns="columns" :records="datasource">
                        <template v-slot="{ record }">
                          <td class="text-nowrap">
                            {{ record.product ? record.product.barcode : '' }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.pro_group_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{
                              record.product
                                ? record.product.product_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{
                              record.unit_of_measure
                                ? record.unit_of_measure.uom_name_en
                                : ''
                            }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.quantity }}
                          </td>
                          <td class="text-center text-nowrap">
                            <a
                              href="#"
                              v-if="record.write_off_detail_serial.length > 0"
                              v-tooltip="$t('writeOff.serial')"
                              class="text-info"
                              @click.prevent="serial(record)"
                            >
                              <i class="fas fa-align-justify"></i>
                            </a>
                          </td>
                        </template>
                      </ts-table>
                    </div>
                    <div class="ts-mt-1 ts-text-right ts-font-bold text-danger">
                      TOTAL : {{ total }}
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="ts-flex ts-row-gap-2 ts-justify-end">
            <ts-button
              @click.prevent="() => $router.push({ name: 'stock-confirm' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="success"
              class="ml-2"
              :waiting="waiting"
              @click.prevent="confirm"
              :disabled="isAlreadyConfirm"
              >{{ $t('stockConfirm.confirm') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal
      v-if="show_modal_confirm"
      v-model="show_modal_confirm"
      :title="$t('stockTransfer.are_you_sure_to_confirm')"
      :centered="true"
      :maskClosable="false"
      :okText="$t('confirm')"
      :zIndex="1020"
      :confirmLoading="waiting"
      width="300px"
      @ok="onConfirm"
      @cancel="onCanel"
    >
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('stockTransfer.confirmDate')
              }}</label>
              <div>
                <a-date-picker
                  class="ts-w-full"
                  :allowClear="false"
                  v-model="received_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  :disabled-date="disabledDate"
                />
                <div class="validate" v-if="errors.has('received_date')">
                  {{ errors.first('received_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </a-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ShowSerials from './show-serial.vue'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })

export default {
  name: 'viewWriteOffDetail',
  data () {
    return {
      waiting: false,
      show_serial: false,
      show_modal_confirm: false,
      status_id: 1,
      datasource: [],
      received_date: null,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('stock/writeOffConfirm', ['edit_data']),
    total () {
      return _.sumBy(this.datasource, function (el) {
        return el.quantity
      })
    },
    columns () {
      return [
        { name: this.$t('writeOff.barcode') },
        { name: this.$t('writeOff.group') },
        { name: this.$t('writeOff.product') },
        { name: this.$t('writeOff.uom'), style: 'text-align:center' },
        { name: this.$t('writeOff.quantity'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px' }
      ]
    },
    isAlreadyConfirm () {
      if (!_.isEmpty(this.edit_data)) {
        return this.edit_data.is_confirm
      }
      return false
    }
  },
  async created () {
    this.loading = true
    await this.find(this.$route.params.id)
    this.loading = false
    this.setDetails()
  },
  methods: {
    ...mapActions('stock/writeOffConfirm', ['find']),
    disabledDate (received_date) {
      // Can not select days before write_off_date
      return (
        received_date < moment(this.edit_data.write_off_date, 'DD-MM-YYYY') ||
        received_date >= moment()
      )
    },
    setDetails () {
      this.datasource = this.edit_data.write_off_details
    },
    format_number (value) {
      return parseFloat(value).toFixed(2)
    },
    serial (item) {
      this.$modal.show(
        ShowSerials,
        {
          data: item
        },
        {
          height: 'auto',
          width: '600px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    confirm () {
      this.show_modal_confirm = true
    },
    async checkReceiveMonthDiffMonthWriteOff (data) {
      try {
        let response = await this.$store.dispatch(
          'stock/writeOffConfirm/checkReceiveMonthDiffMonthWriteOff',
          data
        )
        if (response == 1) {
          this.waiting = false
          if (
            await this.$confirmModal.danger(
              '<span class="text-primary">Month of confirm date and write-off date are different.</span><br /><br />' +
                'Write-off Date: <span class="text-success ts-font-bold">' +
                this.edit_data.write_off_date +
                '</span><br />Confirm Date: <span class="text-success ts-font-bold">' +
                this.received_date +
                '<br /> <br /> <span class="ts-font-bold text-warning">Are you sure to confirm?</span>'
            )
          ) {
            return true
          } else {
            return false
          }
        }
        return true
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.waiting = false
      }
    },
    async onConfirm () {
      this.errors = new Errors()
      this.waiting = true
      if (
        await this.checkReceiveMonthDiffMonthWriteOff({
          write_off_id: this.edit_data.write_off_id,
          received_date: this.received_date,
          write_off_date: this.edit_data.write_off_date
        })
      ) {
        this.waiting = true
        this.$store
          .dispatch('stock/writeOffConfirm/store', {
            write_off_id: this.edit_data.write_off_id,
            received_date: this.received_date
          })
          .then(response => {
            this.$toasted.success(response.message)
            this.$router.push({ name: 'stock-confirm' })
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    onCanel () {
      this.show_modal_confirm = false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/writeOffConfirm/SET_EDIT_DATA', [])
    next()
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
.max-h {
  max-height: 50vh;
}
fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>
